//
// locales/vanilla/de.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/de.json';
import localeData from 'react-intl/locale-data/de.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
